import Vuex from "vuex";

import mutations from './mutations'
import actions from './actions'
import isEmpty from "@/mixins/isempty";

/**
 * Contains state management. For further information visit https://vuex.vuejs.org/
 * TLDR: Use properties for passing information down. Use mutations for updating state values.
 * @type {Store<{konfigModel: {}}>}
 */

const store = new Vuex.Store({
    state: {
        konfigModel: {},
        userData: {},
        isTestDatabaseEnabled: false,
        isTestRulesEnabled: false,
        errorMessageDismissCountDown: 0,
        errorMessage: '',
        loadingIndicator: [],
        downloadIndicator: [],
        csrfToken :'',
        requestQuotationModel: {},
        requestInquiryModel: {},
        notification: 0,
        notificationContent: {},
        isInquiryModalVisible: false,
        isQuotationModalVisible: false,
        validating: false,
        overviewModel: {},
        productAuswahl: {productTree: {},
                         productBreadcrumb: '',
                         productList: {},
                         visible: true,
                         productSizes: {},
                         isProductTreeVisible: true},
        sla: {
            berechnungsStopp: null
        },
        itemFeatures: []
    },

    mutations: mutations,
    actions: actions,

    getters: {
        konfigModel: (state) => {
            return state.konfigModel;
        },
        errorMessage: (state) => {
            return state.errorMessage;
        },
        errorMessageDismissCountDown: (state) => {
            return state.errorMessageDismissCountDown;
        },
        isLoading: (state) => {
            return state.loadingIndicator.length !== 0;
        },
        isDownloading: (state) => {
            return state.downloadIndicator.length !== 0;
        },
        getUserData: (state) => {
            return state.userData;
        },
        isUserExpertenModus: (state) => {
            if (isEmpty.methods.isEmpty(state.userData)) {
                return false;
            }
            return state.userData.defaultModus.endsWith('MODUS_EXPERT');
        },
        requestQuotationModel: (state) => {
            return state.requestQuotationModel;
        },
        requestInquiryModel: (state) => {
            return state.requestInquiryModel;
        },
        showNotification: (state) => {
            return state.notification > 0;
        },
        notificationContent: (state) => {
            return state.notificationContent;
        },
        csrfToken: (state) => {
            return state.csrfToken;
        },
        isInquiryModalVisible: (state) => {
            return state.isInquiryModalVisible;
        },
        isQuotationModalVisible: (state) => {
            return state.isQuotationModalVisible;
        },
        isValidating: (state) => {
            return state.validating;
        },
        overviewModel: (state) => {
            return state.overviewModel;
        },
        productTree: (state) => {
            return state.productAuswahl.productTree;
        },
        productBreadcrumb: (state) => {
            return state.productAuswahl.productBreadcrumb;
        },
        productList: (state) => {
            return state.productAuswahl.productList;
        },
        directAccessVisibility: (state) => {
            return state.productAuswahl.visible;
        },
        productSizes: (state) => {
            return state.productAuswahl.productSizes;
        },
        isProductTreeVisible: (state) => {
            return state.productAuswahl.isProductTreeVisible;
        },
        isTestDatabaseEnabled: (state) => {
            return state.isTestDatabaseEnabled;
        },
        isTestRulesEnabled: (state) => {
            return state.isTestRulesEnabled;
        },
        sla: (state) => {
            return state.sla;
        },
        itemFeatures: (state) => {
            return state.itemFeatures;
        }

    }
});

export default store;